module.exports = __webpack_public_path__ + "img/filter_2.c6a0cee9.svg";